package ir.hosen.resume.screen

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.invert
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import ir.hosen.resume.pages.Theme
import ir.hosen.resume.util.Res
import ir.hosen.resume.util.SkillIcons
import ir.hosen.resume.util.bps
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Img

@Composable
fun ExperiencePartTwoScreen(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier,
        contentAlignment = Alignment.Center
    ) {
        Content(modifier = modifier.width(60.vw))
    }
}

@Composable
private fun Content(modifier: Modifier = Modifier) {
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(32.px)
    ) {
        Row(verticalAlignment = Alignment.Top) {
            SpanText(
                modifier = Modifier.color(Theme.onBackgroundColor).fontFamily(Res.String.ROBOTO_CONDENSED)
                    .fontSize(32.bps()),
                text = "Skills & Tools."
            )
            Img(
                src = "/portal_star.svg",
                attrs = Modifier.size(22.px).filter(invert(if (Theme.isDark) 0 else 1)).toAttrs()
            )
        }

        SimpleGrid(numColumns(base = 1, sm = 2), modifier = Modifier.gap(48.px)) {
            SkillGroup(iconList = SkillIcons.GroupOne.entries.toList())
            SkillGroup(iconList = SkillIcons.GroupTwo.entries.toList())
        }
    }

}

@Composable
private fun SkillGroup(modifier: Modifier = Modifier, iconList: List<SkillIcons.Icon>) {
    Box(
        modifier = modifier.padding(8.px).border(width = 1.px, LineStyle.Solid, color = Colors.Gray).backgroundImage(
            linearGradient(
                dir = LinearGradient.Direction.ToTopLeft,
                from = Theme.onBackgroundColor.copy(alpha = 35),
                to = Theme.backgroundColor
            )
        )
            .borderRadius(10.px), contentAlignment = Alignment.Center
    ) {
        SimpleGrid(
            numColumns = numColumns(base = 2, sm = 4), modifier = Modifier.gap(16.px).padding(24.px)
        ) {
            iconList.forEach { InterestCard(title = it.title, src = it.src) }
        }
    }
}

@Composable
private fun InterestCard(modifier: Modifier = Modifier, title: String, src: String) {
    Box(
        modifier = modifier.size(65.px).border(width = 1.px, LineStyle.Solid, color = Colors.Gray)
            .borderRadius(10.px)
            .padding(28.px).backgroundImage(
                linearGradient(
                    dir = LinearGradient.Direction.ToTopLeft,
                    from = Theme.onBackgroundColor.copy(alpha = 35),
                    to = Theme.backgroundColor
                )
            ), contentAlignment = Alignment.Center
    ) {
        Img(
            src = src, attrs = Modifier.size(42.px).title(title).toAttrs()
        )
    }
}